var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.136,
    height: 18.137,
    viewBox: "0 0 18.136 18.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M12.982,11.426l5.154,5.154L16.58,18.136l-5.154-5.154v-.827l-.292-.292a6.575,6.575,0,0,1-4.376,1.6A6.518,6.518,0,0,1,1.969,11.5,6.491,6.491,0,0,1,0,6.734,6.492,6.492,0,0,1,1.969,1.968,6.488,6.488,0,0,1,6.735,0,6.494,6.494,0,0,1,11.5,1.968a6.517,6.517,0,0,1,1.969,4.79,6.576,6.576,0,0,1-1.6,4.376l.292.292h.827Zm-6.224,0a4.5,4.5,0,0,0,3.306-1.361,4.5,4.5,0,0,0,1.361-3.306,4.5,4.5,0,0,0-1.361-3.306A4.5,4.5,0,0,0,6.758,2.09,4.5,4.5,0,0,0,3.452,3.452,4.5,4.5,0,0,0,2.091,6.758a4.5,4.5,0,0,0,1.361,3.306A4.5,4.5,0,0,0,6.758,11.426Z",
    transform: "translate(0 0.001)",
    fill: "#e2e2e2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.914762e1dc12384ce4a1f68d3d97ec07.svg";
export { ForwardRef as ReactComponent };